module.exports = __webpack_public_path__ + "img/cover-favorite-bg.4e94db41.jpg";